/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useCallback } from "react";
import { Box, Alert } from "@mui/material";
import Button from "@mui/material/Button";
import { USERSIGNUPMESSAGES } from "../../constants/messages";
import Cookies from "js-cookie";
import {
  VERIFICATIONTYPE,
  SIGNINRESPONSES,
  OTPMODE,
  OTPSENTMODE,
  OTPFOR,
  USERINFO,
  OTPSTATUS,
  GLOBALSETTINGS,
  COOKIESNAME,
  SYSTEMSETTINGS,
  LOCALSTORAGENAME,
  AUDITRACEACTIONS,
  VISIBLE_DIGITS,
} from "../../data/constants";
import VerifiedIcon from "@mui/icons-material/Verified";
import useApi from "../../hooks/useApi";
import { verifyUserSignIn, createAndSendOtp } from "../../services/userService";
import {
  verifyOtp,
  updateLoginTimeStamp,
  getEmployeeProfileImage,
} from "../../services/userService";
import { useNavigate, useLocation } from "react-router-dom";
import {
  HrEmployeeOtpDto,
  VerifySignInDto,
  LoginTimeStampDto,
  OtpResponseDto,
} from "../../types/User";
import { IconButton, Dialog, DialogTitle } from "@mui/material";
import BackdropProgressBar from "../../components/ui/BackdropProgressBar";
import CloseIcon from "@mui/icons-material/Close";
import { useUser } from "../../context/UserContext";
import { USERSIGNINMESSAGES } from "../../constants/messages";
import { useSettingValue } from "../../services/useSettingValue";
import { setToken } from "../../utils/commonHelper";
import { useSearchParams } from "react-router-dom";
import CommonResendOtpStatus from "./CommonResendOtpStatus";
import OtpCountDown from "../CommonComponent/OtpCountDown";
import { logAuditTrace } from "../../services/auditNavigationTraceService";
import { getCurrentESTTime } from "../../utils/dateHelper";
import { obfuscateEmail, obfuscatePhone } from "../../utils/maskUtils";
import { getUserModuleRolePermissions } from "../../services/portalUserService";
import { UserModuleRolePermission } from "../../types/UserModuleRolePermission";
import OtpInput from "../CommonComponent/CustomOTP";

interface SignInWithOTPProps {
  // isAdminLocked is only known when the result came from verify-sign-in; omit it and the parent
  // falls back to the neutral lock message rather than guessing the lock reason.
  onCheckIsValidUser: (response: string, isAdminLocked?: boolean) => void;
  onParentAction: () => Promise<boolean>;
  headerText: string;
  userInput: string;
  otpSendTo: string;
  rememberForDevice: boolean;
  deviceId: string;
  onIsSessionLocked: () => void;
}

const SignInWithOTP: React.FC<SignInWithOTPProps> = ({
  onCheckIsValidUser,
  onParentAction,
  headerText,
  userInput,
  otpSendTo,
  rememberForDevice,
  deviceId,
  onIsSessionLocked,
}) => {
  const [otpInput, setOtpInput] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userPhone, setUserPhone] = useState("");

  const [otpStatus, setOtpStatus] = useState({
    isVisibleSendOtp: true,
    isOtpSent: false,
    timer: 30,
    isResendDisabled: true,
    otpErrorMessage: "",
    isVerified: false,
    otpSentTo: "",
  });
  const [otpSentMode, setOtpSentMode] = useState("");
  const [openOTPDialog, setOpenOTPDialog] = React.useState(false);
  const updateOtpStatusState = useCallback((newState: Partial<typeof otpStatus>) => {
    setOtpStatus((prevState) => ({
      ...prevState,
      ...newState,
    }));
  }, []);
  const [validatedUserId, setValidatedUserId] = useState(0);
  const [validatedUserName, setValidatedUserName] = useState("");
  const [validatedFistName, setValidatedFirstName] = useState("");
  const [validatedLastName, setValidatedLastName] = useState("");
  const [isSessionLocked, setIsSessionLocked] = React.useState(false);
  const [isAccountLocked, setIsAccountLocked] = React.useState(false);
  const [timeLeft, setTimeLeft] = useState<number>(0);
  const { loading, executeApi } = useApi();
  const navigate = useNavigate();
  const location = useLocation();
  const { setUserId, setUserName, setFirstName, setLastName, setProfileImage } = useUser();
  const [searchParams] = useSearchParams();
  const firstTextFieldRef = useRef<HTMLInputElement>(null);
  const otpRef = useRef(null);

  const otpFieldLength =
    Number(useSettingValue(SYSTEMSETTINGS.OTP_FIELD_LENGTH)) ||
    GLOBALSETTINGS.DEFAULT_OTP_FIELD_LENGTH;
  useEffect(() => {
    let countdown: ReturnType<typeof setTimeout>;
    if (otpStatus.timer > 0) {
      countdown = setTimeout(() => updateOtpStatusState({ timer: otpStatus.timer - 1 }), 1000);
    } else {
      updateOtpStatusState({ isResendDisabled: false });
    }
    return () => clearTimeout(countdown);
  }, [otpStatus.timer, updateOtpStatusState]);
  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [timeLeft]);
  const handleVerifyPasswordAndSendOtp = async () => {
    if (!(await onParentAction())) return;
    if (!(await onVerifyUserInput())) return;
  };
  const handleSendOtp = async () => {
    if (!(await onVerifyUserInput())) return;
  };

  const onVerifyUserInput = async () => {
    if (!userInput || userInput.trim() === "") {
      onCheckIsValidUser("");
      return false;
    }
    const empAndOtpData: VerifySignInDto = {
      userInput: userInput,
      sessionValue: localStorage.getItem(USERINFO.SESSIONVALUE),
      rememberForDevice: rememberForDevice,
      deviceId: deviceId,
      verificationType: VERIFICATIONTYPE.SENDOTP,
    };
    const userDetails = await executeApi<VerifySignInDto, VerifySignInDto>(
      verifyUserSignIn,
      empAndOtpData,
    );
    if (userDetails.result === SIGNINRESPONSES.VALID_USER && !userDetails.isRoleExist) {
      onCheckIsValidUser(SIGNINRESPONSES.ROLE_NOT_ASSIGNED);
    } else if (userDetails && userDetails.result === SIGNINRESPONSES.VALID_USER) {
      localStorage.setItem(LOCALSTORAGENAME.ROLENAMES, userDetails.roleNames);
      localStorage.setItem(
        LOCALSTORAGENAME.ISFIRSTTIMELOGIN,
        userDetails.isFirstTimeLogin.toString(),
      );
      updateOtpStatusState({ isOtpSent: true });
      focusFirstTextField();
      startTimer();
      updateOtpStatusState({ isVisibleSendOtp: false });
      if (firstTextFieldRef.current) {
        firstTextFieldRef.current.focus();
      }
      setUserEmail(userDetails.cachedEmailAddress);
      setUserPhone(userDetails.cachedPhoneNumber);
      GenerateAndSendOTP(userDetails.cachedEmailAddress, userDetails.cachedPhoneNumber);
      setValidatedUserId(userDetails.userId);
      setValidatedUserName(userDetails.userName);
      setIsAccountLocked(false);
      onCheckIsValidUser(userDetails.result);
      setValidatedFirstName(userDetails.cachedFirstName);
      setValidatedLastName(userDetails.cachedLastName);
      if (userDetails.profileImage) {
        setProfileImage(userDetails.profileImage);
      } else {
        const empProfileImg = await executeApi<number, string>(
          getEmployeeProfileImage,
          userDetails.userId,
        );
        if (empProfileImg) setProfileImage(empProfileImg);
      }
      return true;
    } else if (userDetails.result === SIGNINRESPONSES.INVALID_USER) {
      onCheckIsValidUser(userDetails.result);
    } else if (userDetails.result === SIGNINRESPONSES.SESSION_LOCKED) {
      onCheckIsValidUser(userDetails.result);
    } else if (userDetails.result === SIGNINRESPONSES.ACCOUNT_LOCKED) {
      // Pass the lock reason on so the login screen can tell an admin lock (contact your
      // administrator) from a failed-attempt lockout (a password reset will unlock you).
      onCheckIsValidUser(userDetails.result, userDetails.isAdminLocked);
    } else if (userDetails.result === SIGNINRESPONSES.IP_NOT_WHITELISTED) {
      onCheckIsValidUser(userDetails.result);
    } else if (userDetails.result === SIGNINRESPONSES.ACCOUNT_EXPIRED) {
      onCheckIsValidUser(userDetails.result);
    } else if (userDetails.result === SIGNINRESPONSES.ALREADY_REGISTRED_WITH_PRIMARY_ACCOUNT) {
      onCheckIsValidUser(SIGNINRESPONSES.ALREADY_REGISTRED_WITH_PRIMARY_ACCOUNT);
    }
  };

  const GenerateAndSendOTP = async (email: string, phone: string) => {
    const empAndOtpData: HrEmployeeOtpDto = {
      emailAddress: email,
      phone: phone,
      otpSendTo: otpSendTo,
      otpFor: OTPFOR.SIGNUP,
      sessionValue: localStorage.getItem(USERINFO.SESSIONVALUE),
      mode: OTPMODE.SEND,
    };
    const response = await executeApi<HrEmployeeOtpDto, OtpResponseDto>(
      createAndSendOtp,
      empAndOtpData,
    );
    if (response) {
      updateOtpStatusState({ isOtpSent: true, otpSentTo: response.otpSentTo });
      setOtpSentMode(response.otpSentTo === OTPMODE.EMAIL ? OTPSENTMODE.EMAIL : OTPSENTMODE.PHONE);
      startTimer();
      updateOtpStatusState({ isVisibleSendOtp: false });
      if (firstTextFieldRef.current) {
        firstTextFieldRef.current.focus();
      }
      setTimeLeft(response.verificationTimeOut);
      setOpenOTPDialog(true);
      setTimeout(() => {
        focusFirstTextField();
      }, 100);
      clearOtp();
    }
  };
  const startTimer = () => {
    updateOtpStatusState({ timer: 30, isResendDisabled: true });
  };
  const handleResendOTP = async () => {
    const empAndOtpData: HrEmployeeOtpDto = {
      emailAddress: userEmail,
      phone: userPhone,
      otpSendTo: otpSendTo,
      otpFor: OTPFOR.SIGNUP,
      sessionValue: localStorage.getItem(USERINFO.SESSIONVALUE),
      mode: OTPMODE.SEND,
    };
    const response = await executeApi<HrEmployeeOtpDto, OtpResponseDto>(
      createAndSendOtp,
      empAndOtpData,
    );
    if (response) {
      startTimer();
      clearOtp();
      setTimeLeft(response.verificationTimeOut);
    }
  };
  const handleVerifyOtp = async () => {
    if (!otpInput) {
      updateOtpStatusState({ otpErrorMessage: USERSIGNUPMESSAGES.OTP_CODE_REQUIRED });
      focusFirstTextField();
    } else if (otpInput.length < otpFieldLength) {
      updateOtpStatusState({
        otpErrorMessage: USERSIGNUPMESSAGES.OTP_CODE_6_DIGIT_NUMBER + " " + otpStatus.otpSentTo,
      });
      focusFirstTextField();
    } else {
      const empAndOtpData: HrEmployeeOtpDto = {
        sessionValue: localStorage.getItem(USERINFO.SESSIONVALUE),
        verificationCode: otpInput,
        mode: OTPMODE.VERIFY,
        userId: validatedUserId,
      };
      const response = await executeApi<HrEmployeeOtpDto, OtpResponseDto>(verifyOtp, empAndOtpData);
      if (response.result === OTPSTATUS.MATCHED) {
        onSaveUserDetails();
        setToken(response.authToken);
      } else if (response.result === OTPSTATUS.EXPIRED) {
        updateOtpStatusState({
          otpErrorMessage: USERSIGNUPMESSAGES.OTP_CODE_EXPIRED,
          isVerified: false,
        });
      } else if (response.result === OTPSTATUS.SESSION_LOCKED) {
        setIsSessionLocked(true);
        updateOtpStatusState({
          isVerified: false,
        });
        onCheckIsValidUser(response.result);
        onIsSessionLocked();
      } else if (response.result === SIGNINRESPONSES.ACCOUNT_LOCKED) {
        setIsAccountLocked(true);
        updateOtpStatusState({
          isVerified: false,
        });
        onCheckIsValidUser(response.result);
      } else {
        updateOtpStatusState({
          otpErrorMessage: USERSIGNUPMESSAGES.OTP_CODE_DOES_NOT_MATCH,
          isVerified: false,
        });
      }
    }
  };

  const onSaveUserDetails = async () => {
    const empAndOtpData: LoginTimeStampDto = {
      userId: validatedUserId,
      sessionValue: localStorage.getItem(USERINFO.SESSIONVALUE),
      rememberForDevice: rememberForDevice,
      deviceId: deviceId,
    };
    const updateResult = await executeApi<LoginTimeStampDto, boolean>(
      updateLoginTimeStamp,
      empAndOtpData,
    );
    if (updateResult) {
      setUserId(validatedUserId);
      setUserName(validatedUserName);
      setFirstName(validatedFistName);
      setLastName(validatedLastName);
      if (rememberForDevice) {
        Cookies.set(COOKIESNAME.USERINPUT, userInput, {
          expires: 365,
          secure: true,
          sameSite: "Strict",
        });
        Cookies.set(COOKIESNAME.USERID, validatedUserId.toString(), {
          expires: 365,
          secure: true,
          sameSite: "Strict",
        });
        Cookies.set(COOKIESNAME.REMEMBERME, rememberForDevice.toString(), {
          expires: 365,
          secure: true,
          sameSite: "Strict",
        });
      } else {
        Object.keys(Cookies.get()).forEach((cookieName) => {
          Cookies.remove(cookieName);
        });
      }
      logAuditTrace(
        {
          userId: validatedUserId,
          objectType: AUDITRACEACTIONS.Login,
          objectId: validatedUserId,
          objectName: "User Id " + validatedUserId,
          action: AUDITRACEACTIONS.Login,
          navigationDateTime: getCurrentESTTime(),
        },
        null,
        true,
      );
      goToHome(validatedUserId);
    }
  };

  const clearOtp = () => {
    setOtpInput("");
    otpRef.current?.clear();
    focusFirstTextField();
    updateOtpStatusState({ otpErrorMessage: "" });
  };

  const focusFirstTextField = () => {
    if (!otpRef.current?.isComplete()) {
      otpRef.current?.focusFirstEmpty();
      return;
    }
  };
  const handleCloseDialog = () => {
    setOpenOTPDialog(false);
  };
  const goToHome = async (userId: number) => {
    if (userId && userId > 0) {
      // A page the user was sent here FROM wins over the landing page - see the same guard in
      // SignIn.tsx. Read only in the no-permissions branch below, it never fired for a real user,
      // so an emailed deep link was discarded at login (Epic 79824 AC1).
      const requestedPath = searchParams.get("redirect") || location.state?.from?.pathname;
      if (requestedPath) {
        navigate(requestedPath, { replace: true });
        return;
      }

      const userModuleRolePermissions = await executeApi<number, UserModuleRolePermission[]>(
        getUserModuleRolePermissions,
        userId,
      );
      if (userModuleRolePermissions?.length > 0) {
        const homePage = userModuleRolePermissions.find((x) =>
          x.pageUrl?.includes(GLOBALSETTINGS.DEFAULT_PAGE),
        );
        if (homePage) {
          navigate(homePage.pageUrl, { replace: true });
        } else {
          const firstUrl = userModuleRolePermissions[0].pageUrl;
          navigate(firstUrl, { replace: true });
        }
      } else {
        const redirectPath =
          searchParams.get("redirect") ||
          location.state?.from?.pathname ||
          GLOBALSETTINGS.DEFAULT_PAGE;

        navigate(redirectPath, { replace: true });
      }
    }
  };
  const handleCustomOtpChange = (otp) => {
    setOtpInput(otp);
  };

  return (
    <>
      <BackdropProgressBar loading={loading} />
      <Box textAlign="center">
        <Button
          type="button"
          variant="contained"
          fullWidth
          id="btnLoginUsingOtp"
          onClick={headerText === "And" ? handleVerifyPasswordAndSendOtp : handleSendOtp}
        >
          {headerText === "And" ? "Send OTP and Proceed with Login" : "Login using OTP"}
        </Button>

        {otpStatus.isVerified && (
          <>
            <p>{USERSIGNUPMESSAGES.OTP_VERIFIED_MESSAGE}</p>
            <p>
              <VerifiedIcon className="verified-icon" />
            </p>
          </>
        )}
      </Box>

      <Dialog
        onClose={handleCloseDialog}
        aria-labelledby="customized-dialog-title"
        open={openOTPDialog}
        maxWidth="sm"
        PaperProps={{ sx: { width: 480, height: 420 } }}
      >
        {/* Dialog Title */}
        <DialogTitle
          id="customized-dialog-title"
          sx={{ fontWeight: "bold", textAlign: "center" }}
          className="dialogtitle-font-size"
        >
          OTP Verification for {otpSentMode}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseDialog}
          sx={{
            position: "absolute",
            right: 12,
            top: 12,
            color: "#fff",
          }}
        >
          <CloseIcon />
        </IconButton>
        {otpStatus.isOtpSent && (
          <>
            <BackdropProgressBar loading={loading} />
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={otpStatus.otpSentTo === OTPMODE.EMAIL ? "/otp-email.gif" : "/otp-mobile.gif"}
                alt="description"
                style={{ width: "100px", height: "100px" }}
              />
            </div>
            {isSessionLocked && (
              <Alert severity="error" sx={{ marginBottom: "10px" }} className="alert-alert">
                {USERSIGNINMESSAGES.SESSION_LOCKED_MESSAGE.replace(
                  "{Session_value}",
                  localStorage.getItem(USERINFO.SESSIONVALUE),
                )}
              </Alert>
            )}
            {isAccountLocked && (
              <Alert severity="error" sx={{ marginBottom: "10px" }} className="alert-alert">
                {USERSIGNINMESSAGES.ACCOUNT_LOCKED_MESSAGE}
              </Alert>
            )}
            <div className={isSessionLocked ? "disabled-div" : ""}>
              <Alert severity="error" icon={false} className="alert-alert masked" sx={{ mx: 2 }}>
                We have sent you <strong>One Time Password</strong> to your{" "}
                {otpSentMode === OTPSENTMODE.EMAIL
                  ? `${otpSentMode} (${obfuscateEmail(userEmail)})`
                  : `${otpSentMode} (${obfuscatePhone(userPhone, VISIBLE_DIGITS)})`}
              </Alert>
              {!(isSessionLocked || isAccountLocked) && <OtpCountDown timeLeft={timeLeft} />}
              <div className="div-align">
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    px: 2,
                    marginBottom: "5px",
                  }}
                >
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    gap={2}
                    sx={{
                      flexWrap: "wrap",
                      width: "100%",
                      maxWidth: {
                        xs: "100%",
                        sm: `${otpFieldLength * 63}px`,
                      },
                    }}
                  >
                    <OtpInput
                      length={otpFieldLength}
                      onChange={handleCustomOtpChange}
                      ref={otpRef}
                    />
                  </Box>
                </Box>
                {!(isSessionLocked || isAccountLocked) && (
                  <div>
                    <CommonResendOtpStatus
                      otpErrorMessage={otpStatus.otpErrorMessage}
                      timer={otpStatus.timer}
                      isResendDisabled={otpStatus.isResendDisabled}
                      handleResendOTP={handleResendOTP}
                    />
                  </div>
                )}
                <Button
                  type="button"
                  variant="contained"
                  onClick={handleVerifyOtp}
                  disabled={isSessionLocked || isAccountLocked}
                >
                  Verify And Login
                </Button>
              </div>
            </div>
          </>
        )}
      </Dialog>
    </>
  );
};
export default SignInWithOTP;
